import { useEffect, useRef } from 'react'

export default function EmailProtect({ user, domain }: { user: string; domain: string }) {
  const ref = useRef<HTMLAnchorElement>(null)

  useEffect(() => {
    if (ref.current) {
      const email = `${user}@${domain}`
      ref.current.href = `mailto:${email}`
      ref.current.textContent = email
    }
  }, [user, domain])

  return <a ref={ref} className="text-accent hover:text-accent-hover" />
}
